import axios from 'axios';
import Cookies from 'js-cookie';
import find from 'lodash.find';

import { API_ROUTES, MARKETO } from '../../../constants';

/**
 * Gets utm cookie values and applies them to fields
 *
 * @param fields
 * @returns {{}|*}
 */
const getUTMvalues = (fields) => {
  const utmCookie = Cookies.get(MARKETO.UTM_COOKIE);
  if (!utmCookie) {
    return {};
  }
  let utmValues = {};
  let utmSplit = utmCookie.split('|');

  utmSplit.forEach((utm) => {
    let split = utm.split('=');
    const fieldExists = find(fields, (f) => f.name?.toLowerCase() === split[0]?.toLowerCase());

    if (fieldExists) {
      utmValues[split[0]] = split[1];
    }
  });
  return utmValues;
};

/**
 * Submits any form created in Marketo and built with the Dynamic Form Builder
 *
 * @param fields The array of fields provided by Marketo
 * @param values The entered form values on submission
 * @param programName The Marketo program name associated with the form.
 * @returns {boolean} Success or not
 */
export const submitGenericForm = async (fields, values, programName) => {
  // Gather UTM values from cookies
  const utmValues = getUTMvalues(fields);
  let combined = { ...values, ...utmValues };

  // Remove invalid fields
  for (const key in combined) {
    if (!key || key === 'undefined') {
      delete combined[key];
    }
  }

  const payload = {
    programName: programName,
    fields: combined,
    munchkinId: Cookies.get(MARKETO.MUNCHKIN_COOKIE),
  };

  try {
    const success = await axios.post(API_ROUTES.CREATE_LEAD, payload);
    return { success };
  } catch (e) {
    return false;
  }
};
